import { render } from "./ModalElectionTerms.vue?vue&type=template&id=ed876508&scoped=true"
import script from "./ModalElectionTerms.vue?vue&type=script&lang=js"
export * from "./ModalElectionTerms.vue?vue&type=script&lang=js"

import "./ModalElectionTerms.vue?vue&type=style&index=0&id=ed876508&scoped=true&lang=css"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed876508"]])

export default __exports__